import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import 'datatables.net-rowgroup-dt/css/rowGroup.dataTables.min.css'

import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import {Typeahead} from 'react-bootstrap-typeahead';
import {Table} from 'react-bootstrap';
import Help from '../../../generics/help';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

require( 'datatables.net-rowgroup-dt/js/rowGroup.dataTables.min');

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../../config');

class RegisteredPetitions extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);
		this.checking = this.checking.bind(this);
		this.setTable = this.setTable.bind(this);
		this.dateCompate = this.dateCompare.bind(this);

		this.state = {
			health_facilities_id:"",
			national_centers: [],
			national_center_id:"all",
			start_date 	: "",
			end_date 	: "",
			listado:[],
			//test datatable to export
			columns:[
				{title:'Tipo Petición', width:'150px'},
				{title:'No. Petición', width:'150px'},
				{title:'Fecha', width:'180px'},
				{title:'Paciente', width:'300px'},
				{title:'Estatus', width:'50px'},
				{title:'Genero', width:'50px'}, 
				{title:'Proceso', width:'150px'},
				{title:'Servicio', width:'300px'},
				{title:'Solicitadas', width:'100px'},
				{title:'Detalle Sol.', width:'100px'},
				{title:'Reservadas', width:'100px'},
				{title:'Detalle Res..', width:'100px'},
				{title:'Enviadas', width:'100px'},
				{title:'Detalle Env.', width:'100px'},
				{title:'Confirmadas', width:'100px'},
				{title:'Detalle Conf.', width:'100px'},
				{title:'Turno', width:'150px'}
			],
			filename:"Peticiones Registradas",
			
			national_selected:[{name:'TODOS'}],
	      	indice:-1,
	      	isLoading: false,

			date_hour:"",
			medical:"",
			totales:{
				solicitudes:"0",
				pacientes:"0",
				unidades_solicitadas:"0",
				reservas:"0",
				envios:"0",
				confirmados:"0"
			},
			work_session: "all",
			sessions: [],
			service:"all",
			services:[],
			petition:"all",
			type_petitions:[]
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}

	}

	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)
		
		fetch(Config.default.apiGateway.URL+'national_centers?option=origin_patients', {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					national_centers: response
				});
			}
		});

		fetch(Config.default.apiGateway.URL+'lookups?type=health_services&option=actives&order=true', {
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(msg){
					swal("Error", msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({services:response});
			}
		});

		fetch(Config.default.apiGateway.URL+'work_sessions/actives?health_facilities_id='
			+sessionStorage.getItem('health_facilities_id'), {
			method:'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				})
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({sessions:response});
			}
		})

		fetch(Config.default.apiGateway.URL+'lookups/order_by?type=petition_group_types&option=name', {
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(msg){
					swal("Error", msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({type_petitions:response});
			}
		});

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var hours = this.getHourFormat(aux[1]);
			var date = aux[0].split("/");

			this.setState({
				date_hour:aux[0]+' '+hours,
				start_date:date[2]+'-'+date[1]+'-'+date[0],
				end_date:date[2]+'-'+date[1]+'-'+date[0],
			});
		})


		this.setTable();
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	setTable(){
		
		var fechas = "Información Del: "+moment(this.state.start_date).format("DD/MM/YYYY")+ 
					" Al: "+moment(this.state.end_date).format("DD/MM/YYYY")
		this.$el = $(this.el);
		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [
				{
                	extend: 'excelHtml5',
                	title: this.state.filename
            	},
            	{
                	extend: 'pdf',
                	title: this.state.filename,
                	orientation:"landscape",
                	customize: (doc)=> { 
                		doc.content.unshift({
							image: this.props.header_document,
							alignment:'center',
							width:this.props.w_head
						});
						
						doc.content.splice(2, 0, {text: fechas, margin:[10,0,0,10] });
						
						doc.content[3].table.body.map((body, i)=>{
							
							body.map((b, j)=>{
								if(j>5 && j < body.length - 1){
									b.alignment = 'right';
								}
							})
							
						})

						doc.content.push(
							{text:'Solicitudes: '+this.state.totales.solicitudes+'\t\t'+
								'Pacientes: '+this.state.totales.pacientes+'\t\t'+
								'Unidades Solicitadas: '+this.state.totales.unidades_solicitadas+'\t\t'+
								'Reservas: '+this.state.totales.reservas+'\t\t'+
								'Envios: '+this.state.totales.envios+'\t\t'+
								'Confirmados: '+this.state.totales.confirmados+'\t\t',
							 margin:[0,10,0,10]}
						)
					
                		doc.styles.tableBodyOdd.fillColor = "#FFF";
                		
                		//doc.content[3].table.widths=["10%","10%","10%","10%","10%","5%","5%","5%","5%", "5%","5%","5%","5%","10%"];
                		doc.defaultStyle.fontSize = 6.5; 
                		doc.styles.tableHeader.fontSize = 6.5;
                		doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};
                	} 
            	}
            ],
            /*columnDefs: [ {
		        targets: [4,5,6,7],
		        className: 'dt-right'
    		} ],*/
    		//order: [[ 0, "desc" ]],
			data: this.state.listado,
			columns:this.state.columns,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"fnInfoCallback":null,
			},
			paging:false,
			responsive:false,
			searching: false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: true,
			ordering:false,
			info:false,
			
			createdRow: function(row, data, dataIndex){
				/*$('td:eq(0)', row).attr('style', 'padding-left:4%;');
				
				if(data[2]==='TOTAL'){
					$('td', row).attr('style', 'display:none;');
				}*/
			}
		});
		if (table.rows().indexes().length === 0 ) {
			table.buttons('.buttons-html5').disable();
		}else {
			table.buttons('.buttons-html5').enable();
		}
	}

	handleChange(e){
		if(e.target !== undefined){
			this.setState({
				[e.target.name]: e.target.value
			});
			
			if(document.getElementById(e.target.name).className.includes('error')){
				document.getElementById(e.target.name).classList.remove('error');
			}

			if(e.target.name === 'work_session'){
				this.setState({
					work_session_name: e.target.options[e.target.selectedIndex].text
				})
			}
		}else{
			if(e.length > 0){
				this.setState({
					national_selected:e,
					national_center_id:e[0].id
				});
			}
		}
			
	}

	searching(){
		if(this.isValidForm()){
			if(this.dateCompate()){
				this.props.waiting.handleShow('Buscando...');

				
				var obj = {
					start_date: this.state.start_date,
					end_date: this.state.end_date,
					national_center_id: this.state.national_center_id,
					health_facilities_id:this.state.health_facilities_id,
					work_sessions_id: this.state.work_session,
					health_service:this.state.service,
					petition_type_id:this.state.petition
				}
				
				fetch(Config.default.apiGateway.URL+'reports/petitions_registered',{
					method: 'POST',
					body:JSON.stringify(obj),
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					
					if(res.ok){
						return res.json();
					}else{
						this.props.waiting.handleClose();
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						this.setState({
							listado: [],
						});

						var list = [];

						response.petitions.map((r)=>{
							var obj = [
								r.petition_type,
								r.petition_number,
								moment(r.petition_date).format('DD/MM/YYYY')+' '+
								moment(r.petition_hour, 'HH:mm:ss').format('HH:mm'),
								r.patient,
								r.status,
								r.sex,
								r.process_type,
								r.health_service,
								r.requested,
								r.requested_detail,
								r.reserved,
								r.reserved_detail,
								r.delivered,
								r.delivered_detail,
								r.confirmed,
								r.confirmed_detail,
								r.session,
							];

							list.push(obj);
						});


						var obj = {
							solicitudes:response.totals.total,
							pacientes:response.totals.tot_patients,
							unidades_solicitadas:response.totals.tot_requested,
							reservas:response.totals.tot_reserved,
							envios:response.totals.tot_delivered,
							confirmados:response.totals.tot_confirmed
						};

						this.setState({listado:list, totales:obj});

						setTimeout(()=>{
							this.props.waiting.handleShow('Cargando...');
							this.$el = $(this.el);
							this.$el.DataTable().destroy();
							this.$el.empty();
						}, 500);

						setTimeout(()=>{
							this.props.waiting.handleClose();
							this.setTable();
						}, 1000);
					
							
						this.props.waiting.handleClose();
					}
				});
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}
			
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;
		if(this.state.search_type === 'date'){
			if(ini !== 'Invalid date' && fin !== 'Invalid date'){
				if(fin < ini){
					date_ok = false;
					document.getElementById('end_date').classList.add('error');
				}else{
					document.getElementById('end_date').classList.remove('error');
				}
			}else{
				date_ok = false;
			}		
		}
		

		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	checking(e){
		if(this.state.change_check){
			this.setState({
				change_check: false,
				health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			});
		}else{
			this.setState({
				change_check: true,
			});
		}
	}


	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Pacientes ->
					{this.state.filename}
					</h5>
				</div>
				<Help 
					{...this.props}
	                menu={"help_patients"} 
	                submenu={"help_petitions_registered"}  />
				<div className="form-group" style={{paddingLeft:"0.5em"}}>

					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								
								<div className="form-group">
									<span className="span-min">Fecha Desde</span>
									<input type="date" className="form-control hour-input" name="start_date" id="start_date"
										value={this.state.start_date} onChange={this.handleChange} required  />
								</div>
								<div className="form-group">
									<span className="span-min">Fecha Hasta</span>
									<input type="date" className="form-control hour-input" name="end_date" id="end_date"
										value={this.state.end_date} onChange={this.handleChange} required />
								</div>
								
								<div className="form-group">
									<span className="span-min">Hospital Destino</span>
									<Typeahead
							          	labelKey={(option) => `${option.name}`}
							          	minLength={0}
							          	name="nat_center"
							          	id="nat_center" 
							          	inputProps={{
						          			name:"national_center_id",
						          			id:"national_center_id",
						          			autoComplete:'off'
						          	  	}}
						          	  	className="input_data_donor"
							          	options={this.state.national_centers}
							          	onChange={this.handleChange}
							          	selected={this.state.national_selected}
							          	ref="_handleSearch"
							          	useCache={false}
							          	isLoading={this.state.isLoading}
							          	delay={600}
							          	paginationText="Mostrar mas resultados..."
							        />
									{/*<select className="form-control"  name="national_center_id" id="national_center_id"
										value={this.state.national_center_id} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.national_centers.map((c, i)=>{
											return <option key={i} value={c.id}>
												{c.name}
											</option>
										})}
									</select>*/}
								</div>
								
								<div className="form-group">
									<span className="span-min">Turno</span>
									<select type="text" name="work_session" id="work_session" 
										value={this.state.work_session} onChange={this.handleChange}
										className="form-control" required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.sessions.map((h, i)=>{
											return <option key={i} value={h.id}>
												{h.value}
											</option>
										})}
									</select>
								</div>

								<div className="form-group">
									<span className="span-min">Servicio</span>
									<select type="text" name="service" id="service" 
										value={this.state.service} onChange={this.handleChange}
										className="form-control" required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.services.map((f, i)=>{
											return <option key={i} value={f.key}>
												{f.name}
											</option>
										})}
									</select>
								</div>

								<div className="form-group">
									<span className="span-min">Tipo de Petición</span>
									<select className="form-control" name="petition" id="petition" 
										value={this.state.petition || ""} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.type_petitions.map((p, i)=>{
											return <option key={i} value={p.key}>
												{p.name}
											</option>
										})}
									</select>
								</div>

								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12">
									<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline"}}>
										<span>
											{this.state.filename}
										</span>
									</div>
								</div>
								
								<div className="col-xs-12" >
									<span>
										Información Del:   {this.state.start_date !== "" ? 
											moment(this.state.start_date).format('DD/MM/YYYY')
										:'  '}
									</span>
									<span style={{marginLeft:"5px"}}>	
										Al: {this.state.end_date !== "" ? 
											moment(this.state.end_date).format('DD/MM/YYYY')
										:'  '}
									</span>
								</div>


								<div className="col-xs-12 form-group" id="table-to-pdf">									
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} className={"expenses-discards"} id="table-to-xls" 
											ref={el => this.el = el}>
										</table>
									</div>

								</div>
								<div className="col-xs-12" >									
									
									<span>Solicitudes: </span><label>{' '+this.state.totales.solicitudes}</label>
									<span style={{marginLeft:'10px'}}>Pacientes: </span><label>{' '+this.state.totales.pacientes}</label>
									<span style={{marginLeft:'10px'}}>Unidades Solicitadas: </span><label>{' '+this.state.totales.unidades_solicitadas}</label>
									<span style={{marginLeft:'10px'}}>Reservas: </span><label>{' '+this.state.totales.reservas}</label>
									<span style={{marginLeft:'10px'}}>Envios: </span><label>{' '+this.state.totales.envios}</label>
									<span style={{marginLeft:'10px'}}>Confirmados: </span><label>{' '+this.state.totales.confirmados}</label>
											
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default translate('translations') (RegisteredPetitions);